import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { baseURL } from "../../../configurations/environment";
import { RequestConfig } from "../../../helpers/RequestConfig";

export const getNotificationsRedux = createAsyncThunk(
    "notifications/getNotifications",
    async (params) => {
        let url = `${baseURL}/api/user/notifications`;
        if (params && params.page && params.per_page) {
            url += `?page=${params.page}&per_page=${params.per_page}`;
        }
        const response = await axios.get(url, RequestConfig());
        return response.data && response.data;
    },
);

export const getNotification = createAsyncThunk(
    "notifications/getNotification",
    async (id) => {
        const response = await axios.get(
            `${baseURL}/api/user/notifications/${id}`,
            RequestConfig(),
        );
        return response.data && response.data;
    },
);

export const putUnreadNotification = createAsyncThunk(
    "notifications/putUnreadNotification",
    async (id) => {
        const response = await axios.put(
            `${baseURL}/api/user/notifications/${id}/unread`,
            {},
            RequestConfig(),
        );
        return response.data && response.data;
    },
);

export const getNotificationsSummary = createAsyncThunk(
    "notifications/getNotificationsSummary",
    async () => {
        const url = `${baseURL}/api/user/notifications/notification/summary`;
        const response = await axios.get(url, RequestConfig());
        return response.data;
    },
);

export const markAsReadBulk = createAsyncThunk(
    "notifications/markAsReadBulk",
    async (notificationIds) => {
        const response = await axios.post(
            `${baseURL}/api/user/notifications/mark-as-read-bulk`,
            { notification_ids: notificationIds },
            RequestConfig(),
        );
        return response.data && response.data;
    },
);
